// App.js
import React from 'react';
import './Contact.css';
import ContactForm from '../components/ContactForm';


const Home = () => {
  return (
    <div className="contact">
      <ContactForm />
    </div>
  );
};

export default Home;
